/**
 * qp-meta.ts — LEAF module: queue-page identity + metadata shared by both
 * qp-pages.tsx and qblocks.tsx. Extracted 2026-07-20 to break the
 * qp-pages ↔ qblocks import cycle (qp-pages renders minis via qblocks'
 * QueueBlockView; qblocks needs the page metadata). Import nothing app-side.
 */
export type QPageId = "prebook" | "services" | "locations" | "wait" | "contact" | "waiting" | "noservice" | "csat";

export interface QPageMeta { label: string; sub: string; color: string; tint: string; }
export const QPAGE_META: Record<QPageId, QPageMeta> = {
  prebook:  { label: "Pre-booking",     sub: "Optional — pre-booking questions + content before joining", color: "#DB2777", tint: "#FDEBF3" },
  services: { label: "Services",        sub: "Customer picks the service they need",          color: "#2D60EB", tint: "#E8EEFD" },
  locations: { label: "Pick a location", sub: "Optional — compare wait times across locations", color: "#0E7490", tint: "#E0F2F7" },
  wait:     { label: "Wait Time",       sub: "Shows the approximate wait for that service",   color: "#C8861E", tint: "#FAF1DE" },
  contact:  { label: "Contact Details", sub: "Contact info + booking questions",              color: "#7C3AED", tint: "#F1EAFD" },
  waiting:  { label: "Waiting in queue", sub: "Live position · message the queue host",       color: "#1F8A5B", tint: "#E4F5EF" },
  noservice: { label: "Left without service", sub: "Shown when a customer leaves before being served", color: "#C0392B", tint: "#FBEAE7" },
  csat:     { label: "How did we do?",  sub: "Thank-you + selected survey",                   color: "#0E8A6A", tint: "#E6F5F1" },
};
export const QPAGE_ORDER: QPageId[] = ["prebook", "services", "locations", "wait", "contact", "waiting", "noservice", "csat"];

/** Readable text color for a solid accent background. */
export function qpOnAccent(hex: string): string {
  const h = hex.replace("#", "");
  if (h.length < 6) return "#fff";
  const r = parseInt(h.slice(0, 2), 16), g = parseInt(h.slice(2, 4), 16), b = parseInt(h.slice(4, 6), 16);
  return (0.299 * r + 0.587 * g + 0.114 * b) > 168 ? "#14131F" : "#fff";
}
